export let basePath = "tcmarketing/";
import axios from "../util/request.js";
import { pageInfoToUrl, dataToUrlParam } from '@/util/stringsUtil.js'
import { Toast } from 'vant'
import pick from 'lodash/pick'
import clone from 'lodash/clone'

// 积分商城登录注册同个接口
export function login(data = {}) {
  let _data = clone(data)
  _data = pick(_data, ['platformType', 'device', 'registrationSource', 'sourceType', 'userId', 'userName', 'userPhone'])

  // todo
  _data.platformType = _data.platformType || "HWXS";
  _data.device =  _data.device || "APP";
  _data.registrationSource = _data.registrationSource|| "CBS_APP";
  _data.sourceType = _data.sourceType || "CBS";
  _data.userId = _data.userId || "";
  _data.userName = _data.userName || "";
  _data.userPhone =  _data.userPhone || "";


  // _data.platformType = _data.platformType || "HWXS";
  // _data.device =  _data.device || "APP";
  // _data.registrationSource = _data.registrationSource|| "CBS_APP";
  // _data.sourceType = _data.sourceType || "CBS";
  // _data.userId = _data.userId || "test";
  // _data.userName = _data.userName || "xupengyun";
  // _data.userPhone =  _data.userPhone || "userPhone";


  const url = basePath + "pointUserAPI/pointShopRegister";
  return axios.post(url, _data);
}

// 首页banner
export function getBanner(data = {}) {
  const url = basePath + `pointProductAPI/getRecommendPointProductPagination?pageNo=${1}&pageSize=${10}`;
  return axios.post(url, data);
}

export function request(url, data, mode = 'post') {
  if (mode === 'post') {
  // 转化分页参数至url
  let urlParam = pageInfoToUrl(data)
  if (urlParam) {
    url += urlParam
  }
    return axios.post(url, data);
  } else {
    return axios.get(dataToUrlParam(url, data));
  }
}

// 积分商城请求
export function mallRequest(url, data, mode = 'post') {
  let baseUrl = basePath + url

  return new Promise((resolve, rej) => {
    request(baseUrl, data, mode).then(res => {
      resolve(res)
    }).catch(err => {
      Toast.fail(err || '系统异常')
      rej(err)
    })
  })
}

// 获取省市区
export function findAreaByParentCode(data = {}) {
  let url = `pointUserAddressAPI/findAreaByParentCode`
  return mallRequest(url, data)
}

// 确认收货
export function confirmReceipt(data = {}) {
  let url = `pointOrderAPI/confirmReceipt`
  return mallRequest(url, data, 'get')
}

// 商品分类数据
export function getShopList(data = {}) {
  const url = basePath + `pointProductAPI/getPointProductPagination?pageNo=${data.pageNo}&pageSize=${10}`;
  return axios.post(url, data);
}

// 赚积分
export function getShopPointTask(data = {}) {
  const url = basePath + `apiConfigAPI/findPointShopPointTaskConfig`;
  return axios.post(url, data);
}


// 积分明细
export function getPointsList(data = {}) {
  const url = basePath + `pointFlowAPI/findPointFlowVoPagination?pageNo=${data.pageNo}&pageSize=${10}`;
  return axios.post(url, data);
}

// 积分商品前三
export function getPointProductTOP3(data = {}) {
  const url = basePath + `pointProductAPI/findPointProductTOP3`;
  return axios.get(url, data);
}

// 积分推荐商品前三
export function getRecommendPointProductTOP3(data = {}) {
  const url = basePath + `pointProductAPI/findRecommendPointProductTOP3`;
  return axios.get(url, data);
}

// 订单列表
export function getPointOrderList(data = {}) {
  const url = basePath + `pointOrderAPI/findPointOrderVoPagination?pageNo=${data.pageNo}&pageSize=${10}`;
  return axios.post(url, data);
}

// 获取用户信息
export function getPointUserInfo(data = {}) {
  const url = basePath + `pointUserAPI/getPointUserInfo`;
  return axios.get(url, data);
}


// 积分事件处理
export function getExecPointRuleEvent(data = {}) {
  data.devicePlatform = localStorage.getItem('device') || 'APP'
  data.eventRuleType = data.eventRuleType || 'BROWSE'
  data.eventSourceType = localStorage.getItem('registrationSource') //todo
  const url = basePath + `pointRuleAPI/execPointRuleEvent`;
  return axios.post(url, data);
}


// WEBPACK FOOTER //
// src/api/pointsMall.js